import axios from 'axios'

// Detectar si estamos en desarrollo local o en producción
const getBaseURL = () => {
    const hostname = window.location.hostname;
    // Si accedemos desde localhost, usar localhost con puerto de desarrollo
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return "http://localhost:5058/api/";
    }
    // En producción, usar ruta relativa (nginx proxy a puerto 5000)
    return "/api/";
};

// URL base del servidor (sin /api/) para recursos estáticos como fotos
export const getServerBaseURL = () => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return "http://localhost:5058";
    }
    // En producción, usar misma URL base (nginx proxy /uploads/)
    return "";
};

const instance = axios.create({
    baseURL: getBaseURL()
});

// Interceptor para manejar errores de conexión
instance.interceptors.response.use(
    response => response,
    error => {
        if (error.code === 'ERR_NETWORK') {
            console.error('Error de red - API no disponible en:', getBaseURL());
        }
        return Promise.reject(error);
    }
);

export default instance;
//baseURL: "https://localhost:7058/api/"
//baseURL: "https://droidapi.credi-cloud.com/api/"
//baseURL: "https://droidapidev.credi-cloud.com/api/"